import { render } from "./PaymentSuccessPage.vue?vue&type=template&id=66f9016c&scoped=true&ts=true"
import script from "./PaymentSuccessPage.vue?vue&type=script&lang=ts"
export * from "./PaymentSuccessPage.vue?vue&type=script&lang=ts"

import "./PaymentSuccessPage.vue?vue&type=style&index=0&id=66f9016c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f9016c"]])

export default __exports__